import { createFileRoute } from "@tanstack/react-router";
import { SolucionesPanel, type SolucionTab } from "@/components/soluciones-panel";

const TABS: SolucionTab[] = [
  { label: "Convenio U. Mayor", to: "/cursos/personas/convenio-umayor" },
  { label: "Certificación Mine Class", to: "/cursos/personas/certificacion-mine-class" },
  { label: "Cursos SENCE", to: "/cursos/personas/sence" },
];

export const Route = createFileRoute("/cursos/personas")({
  head: () => ({
    meta: [
      { title: "Cursos Personas | Mine Class" },
      {
        name: "description",
        content:
          "Cursos y diplomados abiertos para trabajadores mineros, estudiantes y profesionales, en alianza con la Universidad Mayor.",
      },
    ],
    links: [{ rel: "canonical", href: "/cursos/personas" }],
  }),
  component: Layout,
});

function Layout() {
  return (
    <SolucionesPanel
      title="Cursos Personas"
      intro="Desarrolla tu carrera en la industria minera con cursos y diplomados de especialización profesional 100% online."
      tabs={TABS}
    />
  );
}
